<template>
  <div>
        <!--删除订单提示窗-->
    <el-dialog :visible.sync="deletePrompt"  width="380px" class="delete-prompt" :show-close="false" top="18%">
        <div class="flex" v-if="deletePromptIndex==1">
            <div class="icon">
                <i class="el-icon-warning-outline"></i>
            </div>
            <div class="delete-text">
                <h2>您确定要删除该订单吗？</h2>
                <span>删除后，您可以在订单回收站还原该订单，也可以做永久删除。</span>
            </div>
        </div>
        <div class="flex" v-if="deletePromptIndex==2">
            <div class="icon icon-check">
                <i class="el-icon-circle-check"></i>
            </div>
            <div class="delete-text">
                <h2>删除订单成功</h2>
                <span>删除后，您可以在订单回收站还原该订单，也可以做永久删除。</span>
            </div>
        </div>
        <div class="flex" v-if="deletePromptIndex==3">
            <div class="icon">
                <i class="el-icon-warning-outline"></i>
            </div>
            <div class="delete-text">
                <h2>您确定要永久删除该订单吗？</h2>
                <span>永久删除后，订单将无法恢复，请谨慎操作。</span>
            </div>
        </div>
        <div class="flex" v-if="deletePromptIndex==4">
            <div class="icon icon-check">
                <i class="el-icon-circle-check"></i>
            </div>
            <div class="delete-text">
                <h2>还原订单成功</h2>
                <span>还原成功！ 您可以在“我的订单”中查看被还原的订单。</span>
            </div>
        </div>
        <div class="flex" v-if="deletePromptIndex==5">
            <div class="icon icon-check">
                <i class="el-icon-circle-check"></i>
            </div>
            <div class="delete-text">
                <h2>永久删除成功！</h2>
            </div>
        </div>
        <div class="flex justify-end mt-4" v-if="deletePromptIndex==1||deletePromptIndex==3">
            <el-button  @click="$emit('close')"  size="small">取消</el-button>
            <el-button  @click="deleteOrderConfirm()"   size="small" type="primary">确定</el-button>
        </div>
        <div class="flex justify-end mt-4" v-if="deletePromptIndex>1&&deletePromptIndex!=3">
            <el-button  @click="$emit('close')"  size="small" type="danger">我知道了</el-button>
        </div>
    </el-dialog>
  </div>
</template>

<script>
import { debounce } from "lodash";
export default {
  name: 'DeletePrompt',
  components: {},
  props: {
    deletePrompt:{
        type:Boolean,
        default:false
    },
    deletePromptIndex:{
        type:Number,
        default:1
    }
  },
  data() {
    return {

    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    //防止连点
    deleteOrderConfirm: debounce(function() {
        this.$emit('deleteOrderConfirm');
    },200),
  }
};
</script>

<style lang="scss" scoped>
    .flex{
        display: flex;

    }
    .justify-end{
        justify-content: flex-end;
    }
    .delete-prompt{
        text-align: left;
    }
    .icon{
        font-size: 24px;
        color: #dc3545;
        margin-right: 10px;
    }
    .icon-check{
        color: var(--smtc-color-green);
    }
    .delete-text{
        h2{
            color: #333;
            font-size: 18px;
        }
        span{
            margin-top: 10px;
            display: block;
        }
    }
</style>
<style>
    .delete-prompt .el-dialog__header{
        padding:0;
    }
</style>

